
export default {
  name: "common-dummy-component",
};
